import { QueryBuilder } from '~/services/promo/query-builder'
import { Operator } from '~/types/promo/firebase'
import { PageBannerDocumentFields } from '~/types/promo/page-banner'

export class PageBannersQuery extends QueryBuilder {
  protected readonly collectionId = 'page-banners'
  protected readonly fields: PageBannerDocumentFields = [
    'campaignId',
    'templateId',
    'visibility',
    'content',
    'isDismissible',
  ]

  constructor (
    protected readonly projectId: string,
    protected readonly dbName: string,
  ) {
    super()
  }

  listByCampaignId (campaignId: string) {
    this.conditions = {
      type: 'composite',
      op: Operator.AND,
      filters: [
        {
          fieldFilter: {
            field: {
              fieldPath: 'campaignId',
            },
            op: Operator.EQUAL,
            value: {
              stringValue: campaignId,
            },
          },
        },
      ],
    }

    return this
  }
}
